// StoreContext.js
import React, { createContext, useContext, useState } from 'react';

const StoreContext = createContext();

export const StoreProvider = ({ children }) => {
  const [isStoreOn, setIsStoreOn] = useState(true); // default: store is ON
  
  const [pilotPOSContext, setPilotPOSContext] = useState(false);
  const toggleStore = () => setIsStoreOn(prev => !prev);
  const setStoreOn = () => setIsStoreOn(true);
  const setStoreOff = () => setIsStoreOn(false);

  return (
    <StoreContext.Provider value={{pilotPOSContext, setPilotPOSContext, isStoreOn, toggleStore, setStoreOn, setStoreOff }}>
      {children}
    </StoreContext.Provider>
  );
};

export const useStore = () => useContext(StoreContext);
